export enum ShippingAddressType {
    /** 自有 */
    OWN = "OWN",
    /** 散客 */
    CASUAL = "CASUAL",
}

export default interface ShippingAddressDTO {
    /**绑定的店铺列表 用,分割 */
    bindingShopIds: string;

    bindingShopIdList?: number[];

    city: string;

    cityCode: number;

    district: string;

    districtCode: number;

    id: number;

    mobile: string;

    /**发货地址名称 */
    name: string;

    province: string;

    provinceCode: number;

    /**发货人姓名 */
    shipperName: string;

    street: string;

    telephone: string;

    zipCode: string;

    /**排序 */
    index: number;

    deleted: boolean;

    type: ShippingAddressType;
}
